import { render, staticRenderFns } from "./ManageTimeslotDialog.vue?vue&type=template&id=87c7d4d4"
import script from "./ManageTimeslotDialog.ts?vue&type=script&lang=ts&external"
export * from "./ManageTimeslotDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./ManageTimeslotDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports